document.addEventListener('DOMContentLoaded', function () {
    if(!document.forms.leasingForm) {
      return;
    }

    const leasingPopup = document.getElementById('leasing-popup');
    const button1 = document.querySelector('.button-container.button-1');
    const button2 = document.querySelector('.button-container.button-2');
    const button3 = document.querySelector('.button-container.button-3');
    document.querySelector('.popup-close-button').addEventListener('click', () => {
        leasingPopup.querySelector('.popup-wrapper').removeAttribute('status');
        leasingPopup.style.display = 'none';
    });

    document.querySelector('.leasing-button').addEventListener('click', () => {
        document.querySelector('#leasing-popup').style.display = 'flex';
    });

    document.querySelectorAll('.info-card').forEach(card => {
        card.addEventListener('click', function () {
            document.querySelectorAll('.info-card').forEach(c => c.classList.remove('active'));
            this.classList.add('active');
            if (button1) button1.style.display = 'flex';
            showInfo(this.getAttribute('data-id'));
        });
    });
    
    if (button1) {
        button1.addEventListener('click', () => {
            document.querySelectorAll('.info-card, .info-section').forEach(el => el.style.display = 'none');
            button1.style.display = 'none';
    
            const activeCard = document.querySelector('.info-card.active');
            if (activeCard) {
                const selectedImage = activeCard.querySelector('img').src;
                const selectedTitle = activeCard.querySelector('h3').innerText;
                const selectedContent = activeCard.querySelector('p').innerText;
    
                // Update the hidden input fields inside the selected info card
                document.querySelector('input[name="contact[leasing_partner_card_title]"]').value = selectedTitle;
                document.querySelector('input[name="contact[leasing_partner_card_content]"]').value = selectedContent;
                console.log("selectedTitle==========>", selectedTitle);
                console.log("selectedContent==========>", selectedContent);
                // Display selected card info in UI
                const displayArea = document.createElement('div');
                displayArea.classList.add('selected-card-display');
                displayArea.innerHTML = `
                    <div class="selected-card-display-image">
                        <img src="${selectedImage}" alt="${selectedTitle}" width="200" height="200">
                        <span class="edit-button edit-1">Bearbeiten</span>
                    </div>
                    <div class="selected-card-display-content">
                        <h3>${selectedTitle}</h3>
                        <p>${selectedContent}</p>
                    </div>
                `;
    
                document.querySelector('.popup-content.content-1').style.display = 'flex';
                document.querySelector('.popup-content.content-1').appendChild(displayArea);
    
                document.querySelector('.popup-content.content-2').style.display = 'block';
                document.querySelector('.head-text.head-2 .number').style.backgroundColor = '#000000';
                document.querySelector('.head-text.head-2 .text-description').style.color = '#000000';
    
                document.querySelector('.edit-button.edit-1').addEventListener('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    displayArea.remove();
                    document.querySelector('.popup-content.content-1').style.display = 'grid';
                    document.querySelectorAll('.info-card, .info-section').forEach(el => el.style.display = 'block');
                    button1.style.display = 'flex';
                });
            }
        });
    }

    if (button2) {
        button2.addEventListener('click', () => {
            let valid = true;
            const errorContainer = document.querySelector('.error-messages');
            errorContainer.innerHTML = '';

            let missingFields = [];
            document.querySelectorAll('.customer-form .form-group input, .customer-form .form-group select').forEach(input => {
                if (!input.value.trim()) {
                    valid = false;
                    const label = input.closest('.form-group')?.querySelector('label');
                    if (label) missingFields.push(label.innerText.trim());
                }

                if (input.name === "contact[email]") {
                    const strictEmailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    if (!strictEmailPattern.test(input.value.trim())) {
                        valid = false;
                        missingFields.push("Ungültige E-Mail-Adresse: Bitte geben Sie eine gültige Adresse ein.");
                    }
                }
            });

            if (!valid) {
                errorContainer.innerHTML = `
                    <div class="error-banner" style="background-color:#cc3c28; color:#000000; font-size:1.5rem; padding:10px; margin-bottom:10px;">
                        <svg role="presentation" focusable="false" width="18" height="18" class="icon icon-warning" style="--icon-height: 18px" viewBox="0 0 18 18">
                        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
                        <path d="M7.98347 10.156V4.504H9.99947V10.156H7.98347ZM10.1675 11.98C10.1675 12.14 10.1355 12.292 10.0715 12.436C10.0155 12.572 9.93147 12.692 9.81947 12.796C9.71547 12.892 9.59147 12.968 9.44747 13.024C9.30347 13.088 9.15147 13.12 8.99147 13.12C8.83147 13.12 8.67947 13.092 8.53547 13.036C8.39947 12.98 8.27947 12.9 8.17547 12.796C8.07147 12.692 7.98747 12.572 7.92347 12.436C7.85947 12.3 7.82747 12.152 7.82747 11.992C7.82747 11.84 7.85547 11.696 7.91147 11.56C7.97547 11.416 8.05947 11.292 8.16347 11.188C8.26747 11.084 8.39147 11.004 8.53547 10.948C8.67947 10.884 8.83147 10.852 8.99147 10.852C9.15147 10.852 9.30347 10.884 9.44747 10.948C9.59147 11.004 9.71547 11.084 9.81947 11.188C9.93147 11.284 10.0155 11.404 10.0715 11.548C10.1355 11.684 10.1675 11.828 10.1675 11.98Z" fill="#ffffff"></path>
                        </svg> Bitte füllen Sie folgende Felder aus: ${missingFields.join(', ')}
                    </div>
                `;
            } else {
                document.querySelector('.customer-form').style.display = 'none';

                const summaryContainer = document.createElement('div');
                summaryContainer.classList.add('form-summary');
                summaryContainer.innerHTML = `
                    <div class="selected-card-display-image">
                        <p>${document.getElementById('first_name').value} ${document.getElementById('last_name').value}</p>
                        <span class="edit-button edit-2">Bearbeiten</span>
                    </div>
                    <p>${document.getElementById('street').value} ${document.getElementById('house_number').value}</p>
                    <p>${document.getElementById('plz').value} ${document.getElementById('city').value}</p>
                    <p>${document.getElementById('country').value}</p>
                    <p>E-Mail: ${document.getElementById('email').value} Telefon: ${document.getElementById('phone').value}</p>
                `;

                document.querySelector('.popup-content.content-2').appendChild(summaryContainer);
                button2.style.display = 'none';
                document.querySelector('.popup-content.content-3').style.display = 'block';

                document.querySelector('.head-text.head-3 .number').style.backgroundColor = '#000000';
                document.querySelector('.head-text.head-3 .text-description').style.color = '#000000';

                document.querySelector('.edit-button.edit-2').addEventListener('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    summaryContainer.remove();
                    document.querySelector('.customer-form').style.display = 'grid';
                    button2.style.display = 'flex';
                });
            }
        });
    }

    if (button3) {
        button3.addEventListener('click', () => {
            const selectField = document.getElementById('payment_options');
            const selectedOption = selectField.value;

            if (selectedOption) {
                document.querySelector('.popup-content.content-4').style.display = 'block';
                document.querySelector('.select-container').style.display = 'none';
                document.querySelector('.button-container.button-3').style.display = 'none';

                const summaryContainer = document.createElement('div');
                summaryContainer.classList.add('selection-summary');
                summaryContainer.innerHTML = `
                    <div class="selected-card-display-image">
                        <p>${selectedOption}</p>
                        <span class="edit-button edit-3">Bearbeiten</span>
                    </div>
                `;

                document.querySelector('.popup-content.content-3').appendChild(summaryContainer);

                document.querySelector('.head-text.head-4 .number').style.backgroundColor = '#000000';
                document.querySelector('.head-text.head-4 .text-description').style.color = '#000000';

                document.querySelector('.edit-button.edit-3').addEventListener('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    summaryContainer.remove();
                    document.querySelector('.select-container').style.display = 'block';
                    document.querySelector('.button-container.button-3').style.display = 'flex';
                });
            }
        });
    }

    window.recommendationsSet = false;

    document.querySelector('#leasingFormSubmit').addEventListener('click', e => {
      if(window.recommendationsSet === true) {
        return;
      }

      e.preventDefault();

      const leasingRecommendations = leasingPopup.querySelector('leasing-recommendations');

      if(leasingRecommendations) {
        leasingRecommendations.recommendations.forEach(({ handle, id, quantity, ptitle, options }, ix) => {
          const input = document.createElement('input');
          input.setAttribute('type',  'hidden');
          input.setAttribute('name',  `contact[addition_${ix+1}]`);
          input.value = `${quantity} x ${ptitle} (${options}) - Variant ID: ${id} - Product Handle: ${handle}`;

          e.target.form.appendChild(input);
        })

        const productData = JSON.parse(document.querySelector('script#product-data-json').textContent);

        const fd = new FormData(e.target.form);

        const entries = {}

        for (const [key, value] of fd.entries()) {
          entries[key] = value;
        }

        localStorage.setItem('leasingd', JSON.stringify({
          source_product: productData,
          form_entries: entries,
          recommendations: leasingRecommendations.recommendations
        }))
      }

      window.recommendationsSet = true;

      e.target.click();
    })

    closePopup();
    
  if(window.location.href.includes('contact_posted=true') && window.location.href.includes('#leasingForm')) {
    leasingPopup.querySelector('.popup-wrapper').setAttribute('status', 'success')
    leasingPopup.style.display = 'flex';

    const lastFormSubmissionData = localStorage.getItem('leasingd');

    if(lastFormSubmissionData && lastFormSubmissionData.trim().length > 0) {
      const { source_product, form_entries, recommendations } = JSON.parse(lastFormSubmissionData);

      let searchQuery = [`${ source_product.handle }|${ source_product.id }|1`];

      if(recommendations && recommendations.length > 0) {
        recommendations.forEach(({ handle, id, quantity }) => searchQuery.push(`${handle}|${id}|${quantity}`))
      }

      searchQuery = searchQuery.join(",");

      fetch(`${Shopify.routes.root}search?q=${searchQuery}&view=leasing-recommendations-submit`).then(f => f.text()).then(html => {
        const contentContainer = document.querySelector('.success-message .content');
        const newContent = document.createElement('div');
        newContent.innerHTML = html;

        const contactFormData = newContent.querySelector('.contact-form-data-wrapper');

        contactFormData.querySelector('.name .value').textContent = `${ form_entries['contact[first_name]'] } ${ form_entries['contact[last_name]'] }`;
        contactFormData.querySelector('.phone .value').textContent = form_entries['contact[phone]'];
        contactFormData.querySelector('.address .value').innerHTML = `${form_entries['contact[house_number]']} ${form_entries['contact[street]']} <br /> ${form_entries['contact[city]']} ${form_entries['contact[plz]']}, ${form_entries['contact[country]']}`;

        contactFormData.querySelector('.partner .value').textContent = form_entries['contact[leasing_partner_card_title]'];

        contentContainer.innerHTML = newContent.innerHTML;
      })
    }
  }
});

function showInfo(id) {
  const leasingPartnersElem = document.getElementById('leasing-partners-data');

  if(!leasingPartnersElem) {
    return;
  }

  const leasingPartners = JSON.parse(leasingPartnersElem.textContent);
  const target = leasingPartners.find(partner => partner.id === id);

  if(!target) {
    return;
  }

  document.querySelector('#info-content .logo').src = target.logo_image_src;
  //document.querySelector('#info-content .title').textContent = target.title;
  document.querySelector('#info-content .content').innerHTML = target.content;

  const website = document.querySelector('#info-content .website');
  website.innerHTML = `<a href="${target.website}">${ target.website_label }</a>`;
}

function closePopup() {
    const leasingPopup = document.getElementById("leasing-popup");
    const popupWrapper = document.querySelector(".popup-wrapper");

    leasingPopup.querySelector('.popup-wrapper').removeAttribute('status');

    // Add click event listener to the whole popup
    leasingPopup.addEventListener("click", function (event) {
        // Check if the clicked area is outside of the popup-wrapper
        if (!popupWrapper.contains(event.target)) {
            leasingPopup.style.display = "none"; // Hide the popup
        }
    });
}
